import { CLASSES } from './constants';

const lockTokens = new Set();
let scrollY = 0;

const syncBodyLockClass = () => {
  const isLocked = lockTokens.size > 0;
  document.documentElement.classList.toggle(CLASSES.OVERFLOW_HIDDEN, isLocked);
  document.body.classList.toggle(CLASSES.OVERFLOW_HIDDEN, isLocked);
};

const lockBodyScroll = (token) => {
  if (!token) return;
  const wasUnlocked = lockTokens.size === 0;
  lockTokens.add(token);

  if (wasUnlocked) {
    scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  syncBodyLockClass();
};

const unlockBodyScroll = (token) => {
  if (!token) return;
  lockTokens.delete(token);

  if (lockTokens.size === 0) {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollY);
    scrollY = 0;
  }

  syncBodyLockClass();
};

export {
  lockBodyScroll,
  unlockBodyScroll
};
